export const insertNestedData = <T extends Record<string, any>>({
  existingRows,
  subRowsToInsert,
  path,
  getRowId,
  subRowKey,
}: {
  existingRows: T[]
  subRowsToInsert: T[]
  path: string[]
  getRowId: (row: T) => string
  subRowKey: string
}): T[] => {
  const id = path[0]
  const isBaseCase = path.length === 1

  if (isBaseCase) {
    return existingRows.map(row => {
      const rowId = getRowId(row)
      if (rowId === id) {
        return {
          ...row,
          [subRowKey]: subRowsToInsert,
        }
      }
      return row
    })
  }

  return existingRows.map(row => {
    const rowId = getRowId(row)
    if (rowId === id && Array.isArray(row[subRowKey])) {
      const [, ...updatedPath] = path
      return {
        ...row,
        [subRowKey]: insertNestedData({
          existingRows: row[subRowKey],
          subRowsToInsert,
          path: updatedPath,
          getRowId: getRowId,
          subRowKey,
        }),
      }
    }
    return row
  })
}
